<div class='main-content'>
  <mat-toolbar color="primary">
    <button mat-icon-button class="logo-wrap" aria-label="company logo" routerLink='/'>
      <img src="../assets/logos/gtap-logo.jpg" />
    </button>
    <a mat-fab color="primary" aria-label="logout button" (click)='logout()' *ngIf='!!(authenticatedUser | async)'>
      <mat-icon>logout</mat-icon>
    </a>
  </mat-toolbar>
  <section class='main-page-content'>
    <router-outlet></router-outlet>
  </section>
</div>
